// ** React Imports
import {useState, createContext, useEffect} from 'react'

// ** Intl Provider Import
// import { IntlProvider } from 'react-intl'

// ** Core Language Data
import messagesEn from '@assets/data/locales/en.json'
import messagesHe from '@assets/data/locales/he.json'
import messagesDe from '@assets/data/locales/de.json'
import messagesFr from '@assets/data/locales/fr.json'
import messagesPt from '@assets/data/locales/pt.json'

// ** User Language Data
import userMessagesEn from '@src/assets/data/locales/en.json'
import userMessagesHe from '@src/assets/data/locales/he.json'
import userMessagesDe from '@src/assets/data/locales/de.json'
import userMessagesFr from '@src/assets/data/locales/fr.json'
import userMessagesPt from '@src/assets/data/locales/pt.json'
import {store} from "../../redux/storeConfig/store";
import {utils_ui} from "../../applyoo/utils/utils_ui";
// ** Menu msg obj
const menuMessages = {
  en: {...messagesEn ,...userMessagesEn},
  he: { ...messagesHe, ...userMessagesHe },
  de: { ...messagesDe, ...userMessagesDe },
  fr: { ...messagesFr, ...userMessagesFr },
  pt: { ...messagesPt, ...userMessagesPt }
}

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({ children }) => {
  let defaultLocale =localStorage.getItem('lang')
  if(!defaultLocale){
    defaultLocale = 'he'
  }
  // ** States
  const [locale, setLocale] = useState(defaultLocale)
  const [messages, setMessages] = useState(menuMessages[defaultLocale])

  const setIsRtl = (prmTitles)=>{

      if(prmTitles) {
        let direction = prmTitles['Settings_LayoutDirection'] || 'RTL'
        let isRtl = (direction === 'RTL')
        store.dispatch({type: 'HANDLE_RTL', value: isRtl});
    }
  }

  setIsRtl(messages);
  // ** Switches Language

  const switchLanguage = lang => {
    localStorage.setItem('lang',lang)
    let lstTitles= require(`@assets/data/locales/${lang}.json`)
    setLocale(lang)
    setMessages(lstTitles)
    setIsRtl(lstTitles)
    utils_ui.setLanguageTitles(lstTitles)

  }

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      {/*<IntlProvider key={locale} locale={locale} messages={messages} defaultLocale={defaultLocale}>*/}
        {children}
      {/*</IntlProvider>*/}
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }
